import React from 'react'
import PropTypes from 'prop-types'
import {
    AspectRatio,
    Box,
    Flex,
    Img,
    Text,
    useMultiStyleConfig,
    Link as ChakraLink,
} from '@chakra-ui/react'
import {Link as RouterLink} from 'react-router-dom'
import SanitizedHtml from '../html-sanitizer'
import {BRAND_KEY} from '../../brand'

let placeholderImage
switch (BRAND_KEY) {
    case 'nutribullet':
        placeholderImage = 'https://dam.delonghigroup.com/800x640/assets/339092'
        break
    case 'kenwood':
        placeholderImage = 'https://dam.delonghigroup.com/562x468/assets/236494'
        break
    case 'braun':
        placeholderImage = 'https://dam.delonghi.com/902x902/assets/360660'
        break
    default:
        placeholderImage = 'https://dam.delonghigroup.com/800x640/assets/244948'
}

const GridCard = ({image, onClick, title, variant, href}) => {
    const styles = useMultiStyleConfig('GridCard', {variant})
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick && onClick()
        }
    }

    // Determine which component to use based on whether href or onClick is provided
    const isAbsoluteUrl = href && /^https?:\/\//.test(href)
    const WrapperComponent = href ? ChakraLink : Flex
    const wrapperProps = href
        ? {
              ...(isAbsoluteUrl ? {href} : {as: RouterLink, to: href}),
              className: 'group',
              onClick: onClick,
              _hover: {textDecoration: 'none'},
              'data-testid': 'grid-card',
          }
        : {
              className: 'group',
              onKeyDown: handleKeyDown,
              tabIndex: 0,
              'data-testid': 'grid-card',
              onClick: onClick,
              role: 'button',
          }

    return (
        <WrapperComponent {...styles.cardContainer} {...wrapperProps} aria-label={title}>
            <Box {...styles.imgWrapper}>
                <AspectRatio ratio={1.5} width="100%">
                    <Box position="relative" width="100%">
                        {image ? (
                            <Img src={image} alt={title} {...styles.tileImage} />
                        ) : (
                            <Img src={placeholderImage} alt="placeholder" {...styles.tileImage} />
                        )}
                        <Box {...styles.gridCardOverlay} />
                    </Box>
                </AspectRatio>
            </Box>
            <SanitizedHtml as={Text} html={title} {...styles.cardText} sanitize={true} />
        </WrapperComponent>
    )
}

GridCard.propTypes = {
    image: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    variant: PropTypes.string,
    href: PropTypes.string,
}

export default GridCard
